import React, {useEffect, useState} from "react";
import useBookingService from "../../api/services/useBookingService";
import BookingsContainer from "../../components/BookingsContainer/BookingsContainer";
import useFunction from "../../hooks/useFunction";
import Loading from "../../components/Loading/Loading";
import Button from "../../components/Button/Button";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";


function UserBookings() {

  const {c} = useFunction()
  const {userShowFilterCollection} = useBookingService()
  const [bookings, setBookings] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [formHeight, setFormHeight] = useState(0)
  const {userAction} = useBookingService()
  const today = new Date()
  const nextYear = new Date()
  nextYear.setFullYear(today.getFullYear() + 1)
  const [dates, setDates] = useState([today, nextYear])

  //concept, requested, accepted, rejected, pay-after, paid, canceled, completed, invalid

  useEffect(() => {
    loadBookings()
  }, [])


  const callbackConfirm = (booking, action, denyReason) => {
    setIsLoading(true)
    userAction(
      (data) => {

        /*
         * Action remove
         */
        if (action === 'remove') {
          if (bookings) {
            const objWithIdIndex = bookings.findIndex((obj) => obj.id === booking.id);
            if (objWithIdIndex > -1) {
              bookings.splice(objWithIdIndex, 1);
            }
          }
          setBookings(bookings)
        } else {

          /*
           * Action cancel-request
           */
          //todo use more nice method...
          loadBookings()
        }
        setIsLoading(false)
      },
      (error) => {
        c('booking update error', error)
      },
      booking.id,
      {
        action: action,
        deny_reason: denyReason,
      },
    )
  }


  useEffect(() => {
    if (!isLoading) {
      setFormHeight(document.getElementById('bookings-container').clientHeight)  //todo use useRef: const inputRef = useRef(null);  ref={inputRef};  access via     console.log('inputRef', inputRef.current);?
    }
  }, [isLoading])

  /**
   * Load bookings
   */
  const loadBookings = (startDate = null, endDate = null) => {
    !isLoading && setIsLoading(true)
    setBookings([])
    userShowFilterCollection(
      (bookings) => {
        setBookings(bookings)
        setIsLoading(false)
      },
      () => {
        //todo
      },
      startDate,
      endDate,
    )
  }

  const handleCalendarChange = (dates) => {
    setDates(dates)
    if (dates.length === 2) {
      const start = typeof dates[0].toDate === "function" ? dates[0].toDate() : dates[0]
      const end = typeof dates[1].toDate === "function" ? dates[1].toDate() : dates[1]

      loadBookings(start.toISOString(), end.toISOString())

      // showBookableRangeBookings(
      //   (bookings) => {
      //     const parsed = parseSpotGroupBookings({...spotGroup, bookings: bookings})
      //     setSpotGroup(parsed)
      //     setBookings(bookings)
      //     setIsLoading(false)
      //   },
      //   (error) => {
      //     setIsLoading(false)
      //   },
      //   'spot_group',
      //   spotGroupId,
      //   dates[0].toString(),
      //   dates[1].toString(),
      // )
    }
  }

  return (
    <div className="page-user-bookings">
      <div className="row">
        <div className="col">
          <h1>Boekingen & Aanvragen</h1>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup
            location="/user/boekingen"
          />
        </div>
      </div>
      {isLoading ?
        <Loading
          height={formHeight}
        />
        :
        <div id="bookings-container">
          <div className="row buttons">
            <Button
              label="Betalingsoverzicht"
              link={'/user/betalingen'}
            />
            <Button
              label="Uitbetalingen"
              link={'/user/bonnen'}
            />
            <br/>
            <br/>
            <br/>
          </div>
          <BookingsContainer
            bookings={bookings}
            callbackConfirm={callbackConfirm}
            handleCalendarChange={handleCalendarChange}
            dates={dates}
            setDates={setDates}
            isLoading={isLoading}
          />
        </div>
      }
    </div>
  )
}

export default UserBookings
